import Request from './Request'

export const AI_CHAT_BOT_FEATURE_FLAG = 'AI Chat Bot'

const isBooleanLikeFlagValue = (value) => (
  typeof value === 'boolean'
  || value === 0
  || value === 1
  || value === '0'
  || value === '1'
)

const normalizeFeatureFlagsMap = (clientOrFlagsMap = {}) => {
  if (!clientOrFlagsMap || typeof clientOrFlagsMap !== 'object') {
    return {}
  }

  if (clientOrFlagsMap.featureFlagsMap && typeof clientOrFlagsMap.featureFlagsMap === 'object' && !Array.isArray(clientOrFlagsMap.featureFlagsMap)) {
    return clientOrFlagsMap.featureFlagsMap
  }

  const featureFlags = clientOrFlagsMap.featureFlags ?? clientOrFlagsMap
  if (Array.isArray(featureFlags)) {
    return featureFlags.reduce((result, flag) => {
      const flagKey = String(flag?.flag_key ?? flag?.flagKey ?? '').trim()
      if (!flagKey) {
        return result
      }

      result[flagKey] = Boolean(flag?.is_active ?? flag?.isActive)
      return result
    }, {})
  }

  const entries = Object.entries(clientOrFlagsMap)
  if (entries.length === 0) {
    return {}
  }

  const looksLikeDirectFlagsMap = entries.every(([key, value]) => {
    if (!key || typeof key !== 'string') {
      return false
    }

    return isBooleanLikeFlagValue(value)
  })

  return looksLikeDirectFlagsMap ? clientOrFlagsMap : {}
}

const isClientFeatureFlagEnabled = (clientOrFlagsMap, flagKey = AI_CHAT_BOT_FEATURE_FLAG) => {
  const featureFlagsMap = normalizeFeatureFlagsMap(clientOrFlagsMap)
  return Boolean(featureFlagsMap?.[flagKey])
}

const getFlags = async (clientId) => {
  const res = await Request.get(`/api/clients/${clientId}/feature-flags`)
  return normalizeFeatureFlagsMap(res?.flags || {})
}

const upsertFlag = async (clientId, flagKey, { is_active, metadata = null }) => {
  return await Request.post(`/api/clients/${clientId}/feature-flags/${flagKey}`, {
    is_active,
    metadata,
  })
}

const updateFeatureFlags = async (clientId, featureFlags) => {
  const featureFlagsMap = normalizeFeatureFlagsMap(featureFlags)

  return await Promise.all(
      Object.entries(featureFlagsMap).map(([flagKey, isActive]) =>
          upsertFlag(clientId, flagKey, { is_active: Boolean(isActive) })
      )
  )
}

const ClientFeatureFlagService = {
  getFlags,
  getFeatureFlags: getFlags,
  upsertFlag,
  updateFeatureFlags,
  normalizeFeatureFlagsMap,
  isClientFeatureFlagEnabled,
}

export default ClientFeatureFlagService

